import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useToast } from '@/shared/hooks/use-toast';

interface DeleteCommentParams {
  commentId: string;
  reason: string;
}

export const useAdminDeleteComment = () => {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: async ({ commentId, reason }: DeleteCommentParams) => {
      const { data, error } = await supabase.functions.invoke('admin-delete-comment', {
        body: { comment_id: commentId, reason }
      });

      if (error) throw error;
      return data;
    },
    onSuccess: () => {
      // Invalidate and refetch comments
      queryClient.invalidateQueries({ queryKey: ['comments'] });
      queryClient.invalidateQueries({ queryKey: ['social-feed'] });
      
      toast({
        title: t('notifications.toasts.admin_comment_deleted'),
        description: t('notifications.toasts.admin_comment_deleted_description'),
      });
    },
    onError: (error: any) => {
      console.error('Error deleting comment:', error);
      toast({
        title: t('notifications.toasts.admin_error_deleting_comment'),
        description: error.message || t('notifications.toasts.admin_error_deleting_comment_description'),
        variant: "destructive",
      });
    },
  });
};
